// extracted by mini-css-extract-plugin
export default {"canvas":"Nolandia_canvas__Hglre","loading":"Nolandia_loading__sivkb","resetButton":"Nolandia_resetButton__teZNJ"};